/* eslint-disable */
import React from 'react';

export default ({ src }) => {
  const validSrc = src.replace('autoplay=1', 'autoplay=0');

  return (
    <iframe
      width="100%"
      height="100%"
      src={validSrc}
      frameBorder="0"
      gesture="media"
      allow="encrypted-media"
      allowFullScreen
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/PostPreview/Video.jsx